// extracted by mini-css-extract-plugin
export default {"root":"e_Y_czMNDl","root_alignmentNo":"ZPansiCTwu","root_alignmentPageContent":"y3TV671cIT","root_hasBorderBottom":"aIy6SsJqyN"};